import * as React from 'react';
import {
  Box,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { IoMdStar } from "react-icons/io";
import trendImg from '../assests/trendImg.png';


const TrendingListCard = () => {

    const listMenu = {
        fontSize:'16px',
        lineHeight:'19.2px',
        fontWeight:'700',
        fontFamily: `"Quicksand", sans-serif`,
        color:'rgba(0, 0, 0, 0.51)',
        '& a':{
            color:'#008BFF',
            marginBottom:'7px',
            display:'block',
            textDecoration:'none',
        },
        '& svg':{
            marginRight:'15px',
            fontSize:'25px',
        },
        '& .ratings':{
            display:'block',
        },
        '& .ratings svg':{
            fill:'#FDCC0D',
            marginRight:'0',
        },
    }
    const trendItems = {
    display:'flex',
        alignItems:'center',
        justifyContent:'space-around',
        marginTop:'10px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.15)',
        padding:'15px 0',
}

    return (
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#fff",
          borderRadius: "15px",
          border: "1px solid #ECECEC",
          boxShadow: "5px 5px 15px 0px #0000000D",
          "& .filterInner": {
            padding: "25px",
          },
        }}
      >
        <div className="filterInner">
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "28.8px",
              fontWeight: "700",
              fontFamily: `"Quicksand", sans-serif`,
              color: "#253D4E",
              paddingBottom: "16px",
              borderBottom: "1px solid #ECECEC",
              position: "relative",
              "&::before": {
                content: `""`,
                width: "80px",
                height: "2px",
                background: "#008BFF",
                position: "absolute",
                left: "0",
                bottom: "0",
              },
            }}
          >
            Trending Now
          </Typography>
          <Box sx={{ width: "100%" }}>
            <Box sx={trendItems}>
              <img src={trendImg} alt="trendimg" />
              <Typography sx={listMenu}>
                <Link to="/product-details">Equipment</Link>$95
                <span className="ratings">
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                </span>
              </Typography>
            </Box>
          </Box>
        </div>
      </Box>
    );
}

export default TrendingListCard;